<template>
    <div class="basic-info">
        <div class="section-title">基本信息</div>
        <div class="w-100">
            <el-button type="primary" @click="handleSubmit">保存</el-button>
        </div>
        <el-form ref="form" :model="localData" label-width="80px" :rules="rules">
            <el-form-item label="名称" prop="name" required>
                <el-input v-model="localData.name" placeholder="请输入名称"></el-input>
            </el-form-item>
            <el-form-item label="SKU" prop="sku" :required="type !== 'single'">
                <el-input v-model="localData.sku" :placeholder="type === 'single' ? '根据所选品牌、分类、属性自动生成' : '请输入SKU'" :disabled="type === 'single'"></el-input>
            </el-form-item>
            <el-form-item label="型号">
                <el-input v-model="localData.model" placeholder="请输入型号"></el-input>
            </el-form-item>
            <el-form-item label="状态">
                <el-select v-model="localData.status" placeholder="请选择状态">
                    <el-option label="在售" :value="1"></el-option>
                    <el-option label="停售" :value="0"></el-option>
                </el-select>
            </el-form-item>
            <el-form-item label="品牌">
                <el-select v-model="localData.brand" placeholder="请输入品牌">
                    <el-option :label="item.nameCn" :value="item.nameCn"  v-for="item in brandList" :key="item.id"></el-option>
                </el-select>
            </el-form-item>
            <template v-if="type === 'single'">
                <el-form-item label="分类">
                    <el-cascader
                        v-model="localData.categoryIdPath"
                        ref="cascaderRef"
                        :options="categoryList"
                        :props="{ value: 'id', label: 'name',checkStrictly: true }"
                        @change="handleChange" clearable>
                    </el-cascader>
                </el-form-item>
                <el-form-item label="属性" v-if="localData.attributes && localData.attributes.length > 0 && localData.attributeData">
                    <div class="attribute-box">
                        <!-- 颜色、页数 -->
                        <div class="attribute-item" v-for="item in localData.attributes" :key="item.id"> 
                            <span class="attribute-name">{{ item.name }}：</span>
                            <el-select v-model="localData.attributeData[item.id]" :placeholder="'请选择'+item.name" filterable clearable>
                                <el-option :label="opt.name" :value="opt.name" v-for="opt in item.options" :key="opt.name"></el-option>
                            </el-select>
                        </div>
                    </div>
                </el-form-item>
            </template>
            

            
            <el-form-item label="附件">
                <el-upload action="#" :auto-upload="false" :file-list="localData.attachments">
                    <el-button size="small" type="primary">上传附件</el-button>
                </el-upload>
            </el-form-item>
            <el-form-item label="描述说明">
                <el-input type="textarea" v-model="localData.description" :rows="10" placeholder="请输入描述说明">
                </el-input>
            </el-form-item>
        </el-form>
    </div>
</template>

<script>
import { ajaxPost, Baseurl } from '@/api/api/api'
export default {
    name: 'BasicInfo',
    props: {
        formData: {
            type: Object,
            required: true
        },
        categoryList: {
            type: Array,
            default: () => []
        },
        brandList: {
            type: Array,
            default: () => []
        },
        type:{
            type: String,
            required: true
        },
        value: {
            type: Boolean,
        }
    },
    data() {
        return {
            localData: {},
            attributes: [],
            categoryCode: '',
            sku: '',
        }
    },
    computed:{
        rules(){
            const rules = {
                name: [
                    { required: true, message: '请输入名称', trigger: 'blur' },
                    { min: 1, max: 50, message: '名称长度在 1 到 50 个字符', trigger: 'blur' }
                ],
            };
            if(this.type !== 'single'){
                rules['sku'] = [
                    { required: true, message: '请输入SKU', trigger: 'blur' },
                    { min: 1, max: 50, message: 'SKU长度在 1 到 50 个字符', trigger: 'blur' }
                ]
            }
            return rules
        }
    },
    watch: {
        formData: {
            handler(newVal) {
                if (newVal) {
                    // 重置表单验证状态
                    if (this.$refs.form) {
                        this.$refs.form.clearValidate()
                    }
                    // 处理状态值为数字类型
                    const processedData = { ...newVal }
                    if (processedData.status !== undefined) {
                        processedData.status = Number(processedData.status)
                    }
                    // 如果是新建产品（没有id），使用初始数据
                    if (!processedData.id) {
                        this.localData = this.getInitialData()
                    }
                    Object.keys(processedData).forEach(key => {
                        this.$set(this.localData, key, processedData[key])
                    })
                }
            },
            immediate: true,
            deep: true
        },
        localData: {
            deep: true,
            handler(val) {
                this.$emit('update:formData', val)
            }
        },
        value: {
            deep: true,
            handler(val) {
                if(val){
                    // 初始化时同步数据并处理状态值
                    const processedData = { ...this.formData }
                    if (processedData.status !== undefined) {
                        processedData.status = Number(processedData.status)
                    }
                    // 如果是新建产品（没有id），使用初始数据
                    if (!processedData.id) {
                        this.localData = this.getInitialData()
                    }
                    Object.keys(processedData).forEach(key => {
                        this.$set(this.localData, key, processedData[key])
                    })
                    this.showCategory();
                }
            }
        }
    },
    created() {
        // // 初始化时同步数据并处理状态值
        // const processedData = { ...this.formData }
        // if (processedData.status !== undefined) {
        //     processedData.status = Number(processedData.status)
        // }
        // // 如果是新建产品（没有id），使用初始数据
        // if (!processedData.id) {
        //     this.localData = this.getInitialData()
        // }
        // Object.keys(processedData).forEach(key => {
        //     this.$set(this.localData, key, processedData[key])
        // })
    },
    methods: {
        getSkuString(){
            const brand = this.brandList.find((item)=>item.nameCn === this.localData.brand);
            const codeArr = [];
            if(this.categoryCode){
                codeArr.push(this.categoryCode);
            }
            if(brand){
                codeArr.push(brand.code)
            }
            const arr = this.localData.attributes;
            for(let i = 0; i < arr.length; i++){
                const item = arr[i];
                if(this.localData.attributeData[item.id]){
                    const value = this.localData.attributeData[item.id];
                    const code = item.options.find((item)=>item.name === value).code;
                    codeArr.push(code);
                }
            }
            let skuString = codeArr.join('-');
            return skuString;
        },
        showCategory(){
            if(Object.keys(this.localData).length === 0){
                return
            }
            const categoryList = this.categoryList;
            const categoryId = this.localData.categoryId;
            let attributes = [];
            const that = this;
            // 查找分类id
            function findPathById(tree, targetId) {
                const path = [];
                function dfs(node, currentPath) {
                    currentPath.push(node.id);
                    if (node.id === targetId) {
                        path.push(...currentPath);
                        attributes = node.categoryAttributes ? node.categoryAttributes.map((item)=>{
                            return {
                                ...item,
                                options: item.value ? JSON.parse(item.value) : []
                            }
                        }) : [];
                        that.categoryCode = node.code;
                        return true;
                    }
                    if (node.children) {
                        for (const child of node.children) {
                            if (dfs(child, [...currentPath])) {
                                return true;
                            }
                        }
                    }
                    return false;
                }
                for (const root of tree) {
                    if (dfs(root, [])) break;
                }
                return path;
            }
            const path = findPathById(categoryList, categoryId);

            const arrs = this.localData.categoryAttributeJSONArray ? this.localData.categoryAttributeJSONArray : [];
            const attributeData = {};
            for(let i = 0; i < arrs.length; i++){
                const item = arrs[i];
                attributeData[item.id] = item.valueArray[0] ? item.valueArray[0].name : '';
            }
            this.$set(this.localData, 'attributes', attributes);
            this.$set(this.localData, 'attributeData', attributeData);
            this.$set(this.localData, 'categoryIdPath', path);

            this.sku = this.localData.sku;
        },
        handleChange(e){
            const nodes = this.$refs.cascaderRef.getCheckedNodes()
            const obj = nodes[0] ? nodes[0].data : {};
            this.attributeData = {};
            if(obj.attribute && obj.categoryAttributes.length > 0){
                const arr = obj.categoryAttributes.map((item)=>{
                    return {
                        ...item,
                        options: item.value ? JSON.parse(item.value) : []
                    }
                })
                this.$set(this.localData, 'attributes', arr)
            }else{
                this.$set(this.localData, 'attributes', []);
            }
            if(Object.keys(obj).length === 0){
                this.$set(this.localData, 'attributeData', {});
                this.$set(this.localData, 'categoryIdPath', []);
            }
            this.categoryCode = obj.code;
        },
        getInitialData() {
            return {
                name: '',
                sku: '',
                model: '',
                brand: '',
                status: '1',
                image: '',
                description: '',
                mainImages: [],
                variants: [],
                variantAttributes: [],
                imagesJson: {
                    mainImages: []
                }
            }
        },
        async handleSubmit() {
            try {
                // 表单验证
                const valid = await this.$refs.form.validate()
                if (!valid) {
                    return false
                }
                // 处理状态值
                const submitData = {
                    ...this.localData,
                    status: Number(this.localData.status)
                }
                // 获取用户信息
                const userInfo = JSON.parse(localStorage.getItem("role"))
                // 设置产品类型和父级级别                
                this.$set(submitData, 'type', this.formData.type)
                this.$set(submitData, 'parentageLevel', this.formData.type === 'variant' ? 'parent' : 'child')
                this.$set(submitData, 'companyId', userInfo.company_id)
                this.$set(submitData, 'rid', userInfo.rid)
                // 如果是单体产品，删除变体相关数据
                if (this.formData.type === 'single') {
                    delete submitData.variantAttributes
                    delete submitData.variants
                    delete submitData.mainImages
                    // 添加属性
                    const arr = this.localData.attributes;
                    const attributeData = this.localData.attributeData;
                    const categoryAttributeJSONArray = [];
                    const categoryId = this.localData.categoryIdPath;
                    for(let k in attributeData){
                        if(attributeData[k]){
                            const item = arr.find((item)=>item.id === +k);
                            if(item){
                                const valueData = item['options'].find((item)=>item.name === attributeData[k]);
                                categoryAttributeJSONArray.push({
                                    "id": +k,
                                    "name": item.name,
                                    "code": item.code,
                                    "valueArray": [valueData]
                                })
                            }
                        }
                    }
                    submitData.categoryId = categoryId[categoryId.length - 1];
                    submitData.categoryAttributeJSONArray = categoryAttributeJSONArray;
                    if(this.localData.categoryIdPath.length === 0){
                        this.$message.error('请先选择分类');
                        return;
                    }
                    if(!submitData.id){ //创建，并且是单体，需要生成序列号
                        if(this.localData.categoryIdPath.length === 0){
                            this.$message.error('请先选择分类');
                            return;
                        }
                        let serialNumber = '';
                        const numParams = {
                            "id": submitData.categoryId,
                            "companyId": userInfo.company_id
                        }
                        const resp = await ajaxPost(Baseurl + '/productCategory/getProductCategoryNo', numParams);
                        if(resp.data.code === 200){
                            serialNumber = resp.data.data + '';
                        }
                        if(serialNumber.length < 3){
                            serialNumber = serialNumber.padStart(3, '0')
                        }
                        const sku = this.getSkuString() + '-' + serialNumber;
                        submitData.sku = sku;
                        this.sku = sku;
                    }
                }
                // 判断是创建还是更新
                let url = '';
                if(submitData.id){ //修改
                    url = `${Baseurl}productController/updateProductLibrary`
                }else{ //创建
                    url = `${Baseurl}productController/createProductLibrary`;
                }
                const response = await ajaxPost(url, submitData)
                if (response.data.code === 200) {
                    this.$message.success('保存基本信息成功!')
                    // 如果是创建，更新本地ID并通知父组件
                    if (!submitData.id && response.data.data) {
                        this.$set(this.localData, 'id', response.data.data);
                    }
                    // 单体的时候赋值分类id和属性
                    if(this.type === 'single'){
                        this.$set(this.localData, 'categoryIdPath', submitData.categoryIdPath);
                        this.$set(this.localData, 'categoryAttributeJSONArray', submitData.categoryAttributeJSONArray);
                        this.$set(this.localData, 'sku', submitData.sku);
                    }
                    this.$emit('update:formData', this.localData)
                } else {
                    this.$message.error(response.data.data || '保存基本信息失败!')
                }
            } catch (error) {
                this.$message.error('保存基本信息失败，请重试!')
            }
        }
    }
}
</script>

<style lang="scss" scoped>
.basic-info {
    position: relative;
    display: flex;
    flex-direction: column;
    background: #fff;

    :deep(.el-textarea__inner) {
        resize: none;
    }

    .section-title {
        font-size: 16px;
        font-weight: bold;
        margin-bottom: 20px;
        padding-bottom: 10px;
        border-bottom: 1px solid #EBEEF5;
    }
}
.attribute-box{
    display: flex;
    align-items: center;
    flex-wrap: wrap;
    
    .attribute-item{
        width: 25%;
        display: flex;
        align-items: center;
        padding-right: 20px;
        box-sizing: border-box;
        .attribute-name{
            margin-right: 10px;
            white-space: nowrap;
        }
        .el-select{
            flex: 1;
        }
    }
}
/deep/ .el-cascader{
    width: 500px;
}

.w-100 {
    width: 100%;
    display: flex;
}
</style>